import { Controller } from "@hotwired/stimulus"

/**
 * RT Film/Digital Toggle Controller
 * Shows/hides method-specific fields based on Film vs Digital radiography selection
 * ISO 17636-1 (Film) vs ISO 17636-2 (Digital CR/DDA)
 */
export default class extends Controller {
  static targets = [
    "selector",      // Film/Digital Selection dropdown
    "filmField",     // Film-specific fields (Screen Type, Screen Thickness, Film Density, Viewing Illuminance)
    "digitalField"   // Digital-specific fields (Detector Pixel Size, Display Luminance, Ambient Light)
  ]

  connect() {
    console.log("RT Film/Digital controller connected")
    // Initialize field visibility on page load
    this.toggleFields()
  }

  toggleFields() {
    if (!this.hasSelectorTarget) {
      console.log("RT Film/Digital selector not found")
      return
    }

    const selectedValue = this.selectorTarget.value
    console.log("RT Film/Digital selection:", selectedValue)

    const isFilm = selectedValue.includes("Film radiography") || selectedValue.includes("ISO 17636-1")
    const isDigital = selectedValue.includes("Digital radiography") || selectedValue.includes("ISO 17636-2")

    // Show/hide film-specific fields
    this.filmFieldTargets.forEach(field => {
      const fieldContainer = field.closest('.col-sm-4')
      if (fieldContainer) {
        if (isFilm) {
          fieldContainer.style.display = 'block'
          // Enable field validation if needed
          const input = fieldContainer.querySelector('input, select')
          if (input) {
            input.disabled = false
            // Enable Tom Select dropdown if present
            if (input.tomselect) {
              input.tomselect.enable()
            }
          }
        } else {
          fieldContainer.style.display = 'none'
          // Disable field validation when hidden
          const input = fieldContainer.querySelector('input, select')
          if (input) {
            input.disabled = true
            // Disable Tom Select dropdown if present
            if (input.tomselect) {
              input.tomselect.disable()
            }
          }
        }
      }
    })

    // Show/hide digital-specific fields
    this.digitalFieldTargets.forEach(field => {
      const fieldContainer = field.closest('.col-sm-4')
      if (fieldContainer) {
        if (isDigital) {
          fieldContainer.style.display = 'block'
          // Enable field validation if needed
          const input = fieldContainer.querySelector('input, select')
          if (input) {
            input.disabled = false
            // Enable Tom Select dropdown if present
            if (input.tomselect) {
              input.tomselect.enable()
            }
          }
        } else {
          fieldContainer.style.display = 'none'
          // Disable field validation when hidden
          const input = fieldContainer.querySelector('input, select')
          if (input) {
            input.disabled = true
            // Disable Tom Select dropdown if present
            if (input.tomselect) {
              input.tomselect.disable()
            }
          }
        }
      }
    })

    // Log visibility state for debugging
    console.log(`RT Fields: Film=${isFilm ? 'visible' : 'hidden'}, Digital=${isDigital ? 'visible' : 'hidden'}`)
  }
}
